import React from 'react';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import AppRoutes from './routes';
import { ThemeProvider } from "@material-tailwind/react";
import { useLocation } from 'react-router-dom';

const App = () => {
  const location = useLocation();
  
  // Rutas donde NO queremos mostrar el footer
  const hideFooterRoutes = ['/auth'];
  const shouldHideFooter = hideFooterRoutes.includes(location.pathname);

  return (
    <div>
      <ThemeProvider>
        <Navbar />
        <AppRoutes />
        {!shouldHideFooter && <Footer />}
      </ThemeProvider>
    </div>
  );
};

export default App;
